<script setup lang="ts">
  const year = new Date().getFullYear();
</script>

<template>
    <div class="layout-footer">
        {{ year }} Pubserv &#169; Get the best price for your traffic
    </div>
</template>
